import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from 'react-switch-lang';
import Button from './MapleButton';
import { events, logAmpEvent } from '../utils/Amplitude';

function PrintButton({ className, ampProp, documentID, ariaLabelKey = 'General_Text_Print_Btn', t, ...props }) {
  return (
    <Button
      className={className ? `printBtn ${className}` : 'printBtn'}
      text={(
        <>
          <FontAwesomeIcon icon={['fal', 'print']} />
          <span>{t('General_Text_Print_Btn')}</span>
        </>
      )}
      onClick={() => {
        logAmpEvent(events.USER_CLICKED_PRINT_BUTTON, ampProp);
        window.Pace.stop();
        window.open(`https://docs.google.com/document/d/${documentID}/export?format=pdf`, '_blank');
      }}
      ariaLabel={t(ariaLabelKey)}
      {...props}
    />
  );
}

export default translate(PrintButton);
